import { render, staticRenderFns } from "./DisplayCommemorativeLicensePlate.vue?vue&type=template&id=41a1f7c3&scoped=true"
import script from "./DisplayCommemorativeLicensePlate.vue?vue&type=script&lang=js"
export * from "./DisplayCommemorativeLicensePlate.vue?vue&type=script&lang=js"
import style0 from "./DisplayCommemorativeLicensePlate.vue?vue&type=style&index=0&id=41a1f7c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a1f7c3",
  null
  
)

export default component.exports